var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01234 16.6667H5.83317C5.39114 16.6667 4.96722 16.4911 4.65466 16.1785C4.3421 15.866 4.1665 15.442 4.1665 15V5.00001C4.1665 4.55798 4.3421 4.13406 4.65466 3.8215C4.96722 3.50894 5.39114 3.33334 5.83317 3.33334H12.4998C12.9419 3.33334 13.3658 3.50894 13.6783 3.8215C13.9909 4.13406 14.1665 4.55798 14.1665 5.00001V11.6667M11.6665 15.8333L13.3332 17.5L16.6665 14.1667M7.49984 6.66668H10.8332M7.49984 10H9.1665",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoIcon);
export default __webpack_public_path__ + "static/media/todo-icon.b061e69d0579a596ab703e982148b7ec.svg";
export { ForwardRef as ReactComponent };